import { Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import moment from "moment/moment";
import { FlatpickrOptions } from "ng2-flatpickr";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AbsencesService } from "../../../../../auth/service/absences.service";
import { UtilsService } from "../../../../../auth/service/utils.service";
import Italian from "flatpickr/dist/l10n/it";
import { AuthenticationService, UserService } from "app/auth/service";
import { IAbsenceForOthers, IAbsenceType } from "app/auth/models/absences";
import { ICurrentUser } from "app/auth/models/user-interface";

@Component({
  selector: "app-staff-add-absence",
  templateUrl: "./staff-add-absence.component.html",
  styleUrls: ["./staff-add-absence.component.scss"],
})
export class StaffAddAbsenceComponent implements OnInit {
  @ViewChild("addAbsence") addAbsence;

  public formGroup: FormGroup;

  public basicDateOptions: FlatpickrOptions;

  public selectedTypeAbsences: number | IAbsenceType;

  public absenceTypesList: IAbsenceType[] = [];

  public absenceTypesListFiltered: IAbsenceType[] = [];

  public requireFile: boolean = false;

  public requireNote: boolean = false;

  private absenceFile: string = "";

  public fileName: string = null;

  public usersList: any = [];

  public categoryAbsence: string = null;

  public listTypesAbsence: string[] = ["Ferie", "Permesso", "Malattia"];

  constructor(
    public _modalService: NgbModal,
    public _authService: AuthenticationService,
    private _formBuilder: FormBuilder,
    public _absencesService: AbsencesService,
    public _utilService: UtilsService,
    public _userService: UserService,
  ) {}

  async ngOnInit() {
    this.formGroup = this._formBuilder.group({
      user: new FormControl(null, [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
      type: new FormControl(null, [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
      note: new FormControl(null, [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
      from: new FormControl(null, [Validators.required, Validators.pattern("^\\d{4}\\-(0?[1-9]|1[012])\\-(0?[1-9]|[12][0-9]|3[01])$")]),
      to: new FormControl(null, [Validators.required, Validators.pattern("^\\d{4}\\-(0?[1-9]|1[012])\\-(0?[1-9]|[12][0-9]|3[01])$")]),
      hour_from: new FormControl(
        {
          hour: 9,
          minute: 0,
        },
        [Validators.required, Validators.minLength(2), Validators.maxLength(2)],
      ),
      hour_to: new FormControl(
        {
          hour: 10,
          minute: 0,
        },
        [Validators.required, Validators.minLength(2), Validators.maxLength(2)],
      ),
    });
    const me: ICurrentUser = this._authService.getCurrentUser();
    this.usersList = await this._userService.getList("employee").then((r: any) => {
      return r.filter((user: any) => user.hash !== me.hash);
    });
    await this.loadAbsencesTypes();
    this.basicDateOptions = {
      altFormat: "d/m/Y",
      defaultDate: "today",
      locale: Italian.it,
      altInput: true,
      utc: true,
      disableMobile: true,
    };
    this.openModal();
  }

  openModal() {
    this._modalService.open(this.addAbsence, {
      centered: true,
      size: "sm",
      backdrop: false,
      keyboard: false,
    });
  }

  async loadAbsencesTypes() {
    this.absenceTypesList = await this._absencesService.getTypeList();
  }

  //Funzione che cambia i tipi di assenza
  changeAbsenceTypesList() {
    //Ad ogni chiamata resetto le variabili principali tranne quella di user
    this.absenceFile = "";
    this.formGroup.patchValue({
      note: "",
      from: "",
      to: "",
      hour_from: {
        hour: 9,
        minute: 0,
      },
      hour_to: {
        hour: 10,
        minute: 0,
      },
    });
    this.formGroup.patchValue({ type: null });
    if (this.categoryAbsence === "Ferie") {
      this.absenceTypesListFiltered = this.absenceTypesList.filter((item) => item.type === "ferie");
    }
    if (this.categoryAbsence === "Malattia") {
      this.absenceTypesListFiltered = this.absenceTypesList.filter((item) => item.type === "malattia" || item.type === "infortunio" || item.type === "maternità");
    }
    if (this.categoryAbsence === "Permesso") {
      this.absenceTypesListFiltered = this.absenceTypesList.filter((item) => item.type === "permesso");
      this.formGroup.patchValue({ to: null });
    }
  }

  setHour() {
    this.formGroup.patchValue({
      hour_to: {
        hour: this.formGroup.value.hour_from.hour + 1,
        minute: this.formGroup.value.hour_from.minute,
      },
    });
  }

  modalClose() {
    this._modalService.dismissAll();
    this.formGroup.reset();
    this._utilService.toggleAbsencePopup("addAbsence");
  }

  checkAdditionalInput() {
    let selectedAbsence: IAbsenceType[] = null;
    if (this.formGroup.value.type) {
      let selectedTypeAbsences: number = this.formGroup.value.type;
      selectedAbsence = this.absenceTypesList.filter((item: IAbsenceType) => item.id === selectedTypeAbsences && (item.require_file === 1 || item.require_note === 1));
      if (selectedAbsence.length > 0) {
        this.requireFile = selectedAbsence[0].require_file === 1;
        this.requireNote = selectedAbsence[0].require_note === 1;
      } else {
        this.requireFile = false;
        this.requireNote = false;
      }
    }
  }

  async handlerChangeFileInput(event: { target: { files: { name: string }[] } }) {
    this.fileName = event.target.files[0].name;
    await this._utilService.convertFileToBase64(event, async (e: { target: { result: string } }) => {
      return (this.absenceFile = e.target.result);
    });
  }

  /*TODO: inserire le traduzioni e modificare quelle esistenti controllare meglio i controlli per i campi mancanti e controllare l'oggetto
       data che mandiamo a seconda della categoria, al cambio categoria assenza si dovrebbero resettare i campi dal al o giorno in caso di permesso*/
  async sendAbsenceRequest() {
    this._utilService.showLoading();
    let hourFrom: { hour: number; minute: number };
    let hourTo: { hour: number; minute: number };
    let from: string | moment.Moment;
    let to: string | moment.Moment;
    let data: IAbsenceForOthers;

    if (!this.formGroup.value.from || this.formGroup.value.from.length == 0) {
      this.formGroup.patchValue({ from: [moment().format("YYYY-MM-DD")] });
    }

    if (this.requireNote && this.formGroup.value.note.length < 1) {
      this._utilService.hideLoading();
      await this._utilService.showSWALError({ text: "ERROR_NOTE_REQUIRE" });
      return false;
    }

    if (this.requireFile && this.absenceFile.length < 1) {
      this._utilService.hideLoading();
      await this._utilService.showSWALError({ text: "ERROR_FILE_REQUIRE" });
      return false;
    }

    if (this.categoryAbsence === "Ferie" || this.categoryAbsence === "Malattia") {
      if ((this.formGroup.value.from && this.formGroup.value.from.length < 1) || (this.formGroup.value.to && this.formGroup.value.to.length < 1)) {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "Una campo data è attualemente vuoto" });
        return false;
      }
      from = moment(this.formGroup.value.from[0]);
      to = moment(this.formGroup.value.to[0]);
      if (to < from) {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "ERROR_DATE_REQUESTED" });
        return false;
      }
      data = {
        type: this.formGroup.value.type,
        from: from.format("YYYY-MM-DD [00:00:00]"),
        to: to.format("YYYY-MM-DD [00:00:00]"),
        note: this.formGroup.value.note,
        user: this.formGroup.value.user,
      };
    } else {
      if ((this.formGroup.value.hour_from && this.formGroup.value.hour_from.length < 1) || (this.formGroup.value.hour_to && this.formGroup.value.hour_to.length < 1)) {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "Una campo orario è attualemente vuoto" });
        return false;
      }
      hourFrom = this.formGroup.value.hour_from;
      hourTo = this.formGroup.value.hour_to;
      const day: moment.Moment = moment(this.formGroup.value.from[0]);

      const dayFrom = day.clone();
      dayFrom.set("hour", hourFrom.hour);
      dayFrom.set("minute", hourFrom.minute);

      const dayTo = day.clone();
      dayTo.set("hour", hourTo.hour);
      dayTo.set("minute", hourTo.minute);

      if (dayTo < dayFrom) {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "ERROR_DATE_REQUESTED" });
        return false;
      }
      data = {
        type: this.formGroup.value.type,
        note: this.formGroup.value.note,
        from: moment(dayFrom).format("YYYY-MM-DD HH:mm:00"),
        to: moment(dayTo).format("YYYY-MM-DD HH:mm:00"),
        user: this.formGroup.value.user,
      };
    }

    await this._absencesService
      .createForOthers(data)
      .then(async (response: { id: number; file_name: string }) => {
        if (this.requireFile) {
          const uploadFile = await this._utilService.upload_media("documents", response.file_name, this.absenceFile);
          if (uploadFile) {
            this._utilService.hideLoading();
            await this._absencesService.updateAbsence(response.id, { has_file: 1 });
          }
        }
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_SEND_HOLIDAY" });
        this.modalClose();
      })
      .catch((response) => {
        if (response === "absence already exist") {
          this._utilService.hideLoading();
          this._utilService.showSWALError({ text: "ERROR_ABSCENCE_ALREADY_REQUESTED" });
        } else {
          this._utilService.hideLoading();
          this._utilService.showSWALError({ text: "ERROR_SEND_HOLIDAY" });
        }
      });
  }
}
